import React from 'react';
import TopicTrends from './TopicTrends';
import useTimelineData from '../../hooks/useTimelineData';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { Col, Row } from 'tea-component';
import CardCommon from '@op/components/CardCommon';
import MainChangeTopics from './MainChangeTopics';
import './index.scss';
import { TopicTypeType } from '../../context';
import { NO_DATE } from '@op/constants';

const titleContentMap: any = {
  all_topic: 'Top 15 Topics',
  key_topic: 'Topic Trends',
};

export default function TopicChartInfo({
  topicType,
}: {
  topicType: TopicTypeType;
}) {
  const { formatMessage } = useLanguage();

  const {
    blockData,
    barAndLine,
    loading,
    apiError,
    tableInfo,
    indicators,
    setIndicators,
    topicLevel,
  } = useTimelineData({});

  return (
    <CardCommon className="dbo-topic-chart-info">
      <Row>
        <Col span={16}>
          <CardCommon
            contentCard
            title={formatMessage({
              id:
                topicLevel === 'L2'
                  ? 'Top 15 Topics'
                  : titleContentMap[topicType] || NO_DATE.EMPTY,
            })}
          >
            <TopicTrends
              timeline={barAndLine}
              topicLevel={topicLevel}
              tableInfo={tableInfo}
              setIndicators={setIndicators}
              indicators={indicators}
              blockData={blockData}
              loading={loading}
            ></TopicTrends>
          </CardCommon>
        </Col>
        <Col span={8}>
          <MainChangeTopics></MainChangeTopics>
        </Col>
      </Row>
    </CardCommon>
  );
}
